import { ValidationStatus } from '../../services/validation';

export enum ContextValidationStatus {
  unknown = 'UNKNOWN',
  poll = 'POLL',
  unknownError = 'UNKNOWN_ERROR',
  failedStepInvalid = 'FAILED_STEP_INVALID',
}

export type ExtendedValidationStatuses = ValidationStatus | ContextValidationStatus;
